import warehouseService from "@/services/warehouse";

export default {
  data() {
    return {
      lastStocktakingDate: null,
    };
  },
  methods: {
    async fetchLastStocktaking(warehouseId) {
      if (!warehouseId) {
        this.lastStocktakingDate = null;
        return;
      }
      try {
        const res = await warehouseService.getWarehouseStocktaking(warehouseId);
        const items = res.data?.data || [];
        const completed = items;
        // .filter((item) => item.documents && item.documents.length > 0)
        // .sort((a, b) => new Date(b.documents[0].created_at) - new Date(a.documents[0].created_at));
        if (completed.length > 0) {
          // this.lastStocktakingDate = this.localeDate(completed[0].documents[0].created_at);
          this.lastStocktakingDate = this.localeDate(completed[0].updated_at, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          });
        } else {
          this.lastStocktakingDate = null;
        }
      } catch (e) {
        this.lastStocktakingDate = null;
      }
    },
  },
  computed: {
    stocktakingHintKey() {
      return "warehouse.last_stocktaking_hint";
    },
  },
  watch: {
    "editedItem.warehouse": {
      handler(warehouse) {
        this.fetchLastStocktaking(warehouse?.id);
      },
      immediate: true,
    },
  },
};
